import { Breadcrumb, ConfigProvider, Typography } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import T from '@/components/common/T'

const { Title, Paragraph } = Typography;

function TheMapPage() {
    const { t } = useTranslation();

    return (
        <main>
            <section
                style={{
                    height: 200,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    backgroundColor: "#d5e8eb",
                    borderRadius: 8,
                    paddingBlock: 25,
                    paddingInline: 50,
                }}
            >
                <Title
                    level={2}
                    style={{
                        textTransform: "uppercase",
                        color: "#2e2525",
                        fontWeight: 600,
                        fontSize: 40,
                        marginBottom: 4,
                    }}
                >
                    <T k="the_map.title" />
                </Title>
                <Breadcrumb
                    separator=">"
                    style={{ fontSize: 20, fontWeight: 500 }}
                    items={[
                        { title: t("the_map.breadcrumb.home") },
                        { title: t("the_map.breadcrumb.the_map") },
                    ]}
                />
            </section>

            <section style={{ padding: "40px 50px" }}>
                <ConfigProvider
                    theme={{
                        token: {
                            fontSize: 16,
                            lineHeight: "1.2"
                        }
                    }}
                >
                    <Paragraph><T k="the_map.p1" /></Paragraph>
                    <Paragraph><T k="the_map.p2" /></Paragraph>
                    <Paragraph>
                        <T k="the_map.p3_intro" />
                        <ul style={{ listStyleType: "disc", marginLeft: 15, marginBlock: "revert" }}>
                            <li style={{ marginBottom: 10 }}><T k="the_map.li1" /></li>
                            <li style={{ marginBottom: 10 }}><T k="the_map.li2" /></li>
                            <li style={{ marginBottom: 10 }}><T k="the_map.li3" /></li>
                            <li style={{ marginBottom: 10 }}><T k="the_map.li4" /></li>
                        </ul>
                    </Paragraph>
                    <Paragraph><T k="the_map.p4" /></Paragraph>
                    <Paragraph><T k="the_map.p5" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="the_map.p6" /></Paragraph>
                </ConfigProvider>
            </section>
        </main>
    )
}

export default TheMapPage
